import { CompleteProfileOnboarding } from './CompleteProfileOnboarding';
import { CompleteYourProfile } from './CompleteYourProfile';
import { ConfirFirstAssistantOnboarding } from './ConfirFirstAssistantOnboarding';
import { ConfirmBusinessPhoneNumber } from './ConfirmBusinessPhoneNumber';
import { ConfirmEmailOnboarding } from './ConfirmEmailOnboarding';
import { ConfirmPhoneCodeOnboarding } from './ConfirmPhoneCodeOnboarding';
import { ConfirmPhoneOnboarding } from './ConfirmPhoneOnboarding';
import { EnterTheCodeWeJustSent } from './EnterTheCodeWeJustSent';
import { ForgotPasswordOnboarding } from './ForgotPasswordOnboarding';
import { InsertBusinessPhoneNumber } from './InsertBusinessPhoneNumber';
import { InsertBusinessWebsiteOnboarding } from './InsertEmailAndWebsiteOnboarding';
import { LoginOnboarding } from './LoginOnboarding';
import { PersonalizeYourAssistant } from './PersonalizeYourAssistant';
import { PersonalizingAssistantOnboarding } from './PersonalizingAssistantOnboarding';
import { ShapeYourFirstAssistant } from './ShapeYourFirstAssistant';

export const LoginOnboardingPage = () => {
  return <LoginOnboarding />;
};

export const ForgotPasswordOnboardingPage = () => {
  return <ForgotPasswordOnboarding />;
};

export const ConfirmPhoneOnboardingPage = () => {
  return <ConfirmPhoneOnboarding />;
};

export const ConfirmPhoneCodeOnboardingPage = () => {
  return <ConfirmPhoneCodeOnboarding />;
};

export const InsertBusinessWebsiteOnboardingPage = () => {
  return <InsertBusinessWebsiteOnboarding />;
};

export const InsertBusinessPhoneNumberPage = () => {
  return <InsertBusinessPhoneNumber />;
};

export const ConfirmBusinessPhoneNumberPage = () => {
  return <ConfirmBusinessPhoneNumber />;
};

export const ConfirFirstAssistantOnboardingPage = () => {
  return <ConfirFirstAssistantOnboarding />;
};

export const PersonalizingAssistantOnboardingPage = () => {
  return <PersonalizingAssistantOnboarding />;
};

export const CompleteProfileOnboardingPage = () => {
  return <CompleteProfileOnboarding />;
};

export const ShapeYourFirstAssistantPage = () => {
  return <ShapeYourFirstAssistant />;
};

export const PersonalizeYourAssistantPage = () => {
  return <PersonalizeYourAssistant />;
};

export const CompleteYourProfilePage = () => {
  return <CompleteYourProfile />;
};

export const ConfirmEmailOnboardingPage = () => {
  return <ConfirmEmailOnboarding />;
};

export const EnterTheCodeWeJustSentPage = () => {
  return <EnterTheCodeWeJustSent />;
};
